<template>
  <div>
    <StepForMobile
      :currentStep="2"
      :screenType="screenType"
      :title="this.$t('Select Files')"
    />
    <div
      v-if="screenType === 'desktop' || uploadStep === 2"
      :class="screenType !== 'desktop' && 'wrapper-2 pa-2'"
    >
      <FileDirButtons
        class="my-2"
        :session="session"
        :lightSessionRestart="() => null"
      />

      <FilesTableForMobile
        v-if="
          screenType !== 'desktop' &&
          uploadStep === 2 &&
          session.filesData.length
        "
        :session="session"
      />

      <SelectedFilesList
          v-else-if="session?.filesData?.length"
          :session="session"
        />
<Totals class="mt-2" :filesData="session?.filesData" v-if="session?.filesData?.length" />
        <div v-else></div>
      <div class="button-wrapper">
        <!-- <Totals :filesData="session?.filesData" v-if="session?.filesData?.length" />
        <div v-else></div> -->
        <div v-if="showErrMsg && !getIsInMiddleOfFilteringData">
          <transition name="slide-fade">
            <span class="mr-8 red--text message fs-1r">{{ errorMessage }}</span>
          </transition>
        </div>
        <div v-else></div>
        <div
          @mouseover="setIsShowErrMsg(true)"
          @mouseleave="setIsShowErrMsg(false)"
        >
          <Button
            :clickAction="startFilteringClicked"
            :text="$t(`Send`)"
            :disabled="!!errorMessage || getIsInMiddleOfFilteringData"
            class="custom-button"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StepForMobile from '@/components/WebsiteInterface/CommonComponents/StepForMobile.vue'
import FileDirButtons from '@/components/WebsiteInterface/CommonComponents/FileDirButtons/FileDirButtons.vue'
import FilesTableForMobile from '@/components/WebsiteInterface/CommonComponents/Mobile/FilesTableForMobile.vue'
import Totals from '@/components/CasualInterface/CasualUpload/Totals.vue'
import Button from '@/components/BaseComponents/Button/Button.vue'
import SelectedFilesList from '@/components/CasualInterface/CasualUpload/SelectedFilesList.vue'
import { mapGetters } from 'vuex'
export default {
  name: 'SelectFilesWrapper',
  props: {
    session: Object,
    startFilteringClicked: Function,
    errorMessage: String,
    screenType: String,
    showErrMsg: Boolean,
    setIsShowErrMsg: Function,
  },
  computed: {
    ...mapGetters(['uploadStep', 'getIsInMiddleOfFilteringData']),
  },
  components: {
    StepForMobile,
    FileDirButtons,
    FilesTableForMobile,
    Totals,
    Button,
    SelectedFilesList,
  },
}
</script>

<style scoped lang="scss">
    .button-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 8px;
    margin: 8px;

    .custom-button {
      width: 140px;
      font-size: 24px !important;
      height: 36px !important;
    }
  }
</style>